// extracted by mini-css-extract-plugin
module.exports = {"inner":"shared-module--inner--2Ml9V","noContent":"shared-module--noContent--20sLW"};